import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message, Modal } from 'antd';
// import { getProfileCompany } from '../../redux/actions/profile_company';
import { getImageOffice } from '../../redux/actions/upload';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';
import { Tabs } from 'antd';
import { getHomeImageCompany } from '@/redux/actions/homeSlide';

const { TabPane } = Tabs;

export default function About(props) {
  const [isShowModal, setIsShowModal] = useState(false);
  const refYoutobe = useRef();
  const refClickYoutobe = useRef();
  const [list_image_office, setListImageOffice] = useState([]);
  const [display_modal, setDisplayModal] = useState('none');
  const [data_modal, setDataModal] = useState({});
  const [profile, setProfile] = useState();
  const trans = useTrans();
  const [company, setCompany] = useState([]);
  const wrapperRef = useRef(null);

  const [flag, setFlag] = useState(false);

  const onChange = key => {
    setFlag(!flag);
  };

  const useOutsideAlerter = ref => {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDisplayModal('none');
        }
      }

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  useEffect(() => {
    if (display_modal === 'block') {
      document.querySelectorAll('.modal-body-top')[0]?.scrollIntoView(false);
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'scroll';
    }
  }, [display_modal]);

  useOutsideAlerter(wrapperRef);

  const handleClickOut = event => {
    const { target } = event;
    if (
      refYoutobe &&
      refClickYoutobe &&
      refClickYoutobe.current &&
      refYoutobe.current &&
      !refYoutobe.current.contains(target) &&
      !refClickYoutobe.current.contains(target)
    ) {
      setIsShowModal(false);
    }
  };
  useEffect(() => {
    getListImageOffice();
    // getProfile();
    window.addEventListener('click', handleClickOut);
    return () => {
      window.removeEventListener('click', handleClickOut);
    };
  }, []);
  const getListImageOffice = async () => {
    const data = await getImageOffice();
    setListImageOffice(data);
  };
  // const getProfile = async () => {
  //     const data = await getProfileCompany();
  //     setProfile(data);
  // };
  useEffect(() => {
    (async () => {
      const imgCompany = await getHomeImageCompany();
      console.log(imgCompany);
      setCompany(imgCompany);
    })();

    console.log(company);
  }, []);

  const setting_office = {
    className: 'center',
    centerMode: true,
    dots: false,
    infinite: true,
    // autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/img/slider/preSlide.png" />
      </button>
    ),
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/img/slider/nextSlide.png" />
      </button>
    ),
  };

  // some-image-slider

  const setting = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    arrows: false,
    dots: true,
    loop: false,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          vertical: true,
          verticalSwiping: true,
        },
      },
    ],
    nextArrow: <div></div>,
    prevArrow: <div></div>,
    customPaging: index => {
      return <button>{index === 6 ? 2012 : 2022 - index}</button>;
    },
  };
  const data_array = [
    {
      name: 'Nguyễn Quý Đức',
      job: 'CEO / TCOM JAPAN',
      image: '/assets/images/about/member.webp',
      image_md: '/assets/images/about/md-member-1.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Đinh Quốc Cường',
      job: 'CEO / TCOM',
      image: '/assets/images/about/member2.webp',
      image_md: '/assets/images/about/md-member-2.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Nguyễn Văn Phương',
      job: 'CEO / TSoft',
      image: '/assets/images/about/member3.webp',
      image_md: '/assets/images/about/md-member-3.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Lê Xuân Hà',
      job: 'CCO / TSoft',
      image: '/assets/images/about/member4.webp',
      image_md: '/assets/images/about/md-member-4.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Nguyễn Trọng Hoà',
      job: 'CTO / TCOM, CEO / EyeFire',
      image: '/assets/images/about/member5.webp',
      image_md: '/assets/images/about/md-member-5.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Lê Minh Sơn',
      job: 'Chief of Mobile Department',
      image: '/assets/images/about/member6.webp',
      image_md: '/assets/images/about/md-member-6.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Ngô Trung Hiếu',
      job: 'Chief of Blockchain Department',
      image: '/assets/images/about/member7.webp',
      image_md: '/assets/images/about/md-member-7.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Lê Quốc Hưng',
      job: 'Chief of Infra Department',
      image: '/assets/images/about/member8.webp',
      image_md: '/assets/images/about/md-member-8.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Ngô Thị Phương Thảo',
      job: 'QA/QC Leader',
      image: '/assets/images/about/member9.webp',
      image_md: '/assets/images/about/md-member-9.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'Nguyễn Văn Tuấn',
      job: 'Design Leader',
      image: '/assets/images/about/member10.webp',
      image_md: '/assets/images/about/md-member-10.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
  ];
  const displayModal = item => {
    setDisplayModal('block');
    // document.getElementsByClassName('modal-body-top')[0]?.scrollIntoView(false);
    // document.body.style.overflow = "hidden";
    setDataModal(item);
  };
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '60px',
    slidesToShow: 1,
    speed: 500,
  };

  const dataSeo = {
    url: process.env.NEXT_PUBLIC_SEO_URL,
    type: 'website',
    title: ' Về chúng tôi | TCOM Global ',
    description: 'TCOM Global',
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    // image: 'https://staging.tcom-japan.com/assets/images/about/gallery-2.png',
    card: 'summary_large_image',
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <div id="about">
        <div className="main-content">
          <div className="r-top-banner">
            <img
              className="w-100"
              src="/assets/img/slider/slider_about.png"
              alt=""
            />
            <div className="content-sp">
              <h3>{trans?.about?.title}</h3>
              <p>{trans?.about?.desc}</p>
            </div>
          </div>
          <img
            className="w-100 img-about-us-sp"
            src="/assets/images/about/about-us-sp.png"
            alt=""
          />
          <div className="r-about-us">
            <div className="container">
              <div className="row about-row">
                <div className="col-12 col-lg-5 col-left about-col-left">
                  <img
                    className="img-about-us-pc"
                    src="/assets/img/slider/our_img.png"
                    alt=""
                  />
                </div>
                <div className="col-12 col-lg-7 col-right about-col-right">
                  <div className="box">
                    <div className="title-left">
                      <h3>{trans?.about?.our_title}</h3>
                      <p>{trans?.about?.our_text}</p>
                      <p>{trans?.about?.our_sub}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="about-containers">
            <div className="title-center">
              <h3>{trans?.about?.images}</h3>
            </div>
            <div className="r-company-profile r-company-profile-about">
              <div className="container container-about">
                <div>
                  <div className="row row-pc">
                    <div className="col-12 col-lg-12">
                      <div className="inner">
                        <div
                          id="about"
                          style={{
                            paddingTop: '100px',
                          }}
                        >
                          <div className="r-office-tcom r-office-tcoms">
                            <div className="container-fluid">
                              <div className="row" style={{ display: 'flex' }}>
                                <div className="col-12 col-xl-9 col-right">
                                  <div className="tcom-image tcom-images">
                                    <Slider {...setting_office}>
                                      {company &&
                                        company?.map(data => {
                                          return (
                                            <div className="item" key={data.id}>
                                              <img
                                                src={data.url}
                                                alt={data.name}
                                              />
                                            </div>
                                          );
                                        })}
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="r-our-team">
            <div className="container">
              <div className="title-center">
                <h3>{trans?.about?.us_title}</h3>
              </div>
            </div>
            <div className="inner">
              <div className="label">OUR TEAM</div>
              <div className="box-content">
                <ul>
                  {/* Modal */}
                  {/* <div className='box' onClick={() => { setDisplayModal(true); }} data-toggle='modal' data-target='#exampleModal'> */}
                  <div
                    className={
                      display_modal === 'block' ? 'modal show' : 'modal fade'
                    }
                    id="exampleModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div
                      className="modal-dialog"
                      role="document"
                      ref={wrapperRef}
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <button
                            onClick={() => {
                              setDisplayModal('none');
                              // document.getElementById('header').classList.remove("sticky");
                              // console.log('kkkkkkkkk', document.getElementById('header'));
                              // document.body.style.overflow = "scroll"
                            }}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="modal-body-top"></div>
                          <div
                            className="row content-notext"
                            style={{ width: '100%' }}
                          >
                            <div
                              className="wrap-avatar"
                              style={{ display: 'flex' }}
                            >
                              <div className="avatar" style={{ width: '45%' }}>
                                <img
                                  className="img-fluid"
                                  src={data_modal.image_md}
                                  alt=""
                                />
                              </div>
                              <div
                                className=" wrap-profiles"
                                style={{ width: '55%' }}
                              >
                                <div className="profiles">
                                  <h3>{data_modal.name}</h3>
                                  <div className="position">
                                    {data_modal.job}
                                  </div>
                                  <p>{data_modal.description}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end modal */}
                  {data_array.map(item => {
                    return (
                      <li>
                        <div
                          onClick={() => {
                            displayModal(item);
                          }}
                          className="box"
                          data-toggle="modal"
                          data-target="#exampleModal"
                        >
                          <div className="image">
                            <img
                              width={202}
                              height={200}
                              src={item.image}
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h3 className="name">{item.name}</h3>
                            <p>{item.job}</p>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                  {/* </div> */}
                </ul>
              </div>
            </div>
          </div>
          {/* -company*/}
          <div className="r-company">
            <div className="container">
              <div className="title-center">
                <h3 className="text-white">{trans?.about?.profile_title}</h3>
                <p>{trans?.about?.profile_text1}</p>
              </div>
              <div className="handleDown">
                {
                  <div>
                    <a
                      style={{ textDecoration: 'none' }}
                      // href={profile?.config_value?.url} download={(profile && profile.config_value && profile.config_value.url) ? true : false}
                      className="text-white"
                    >
                      <span>{trans?.about?.download}</span>
                      <svg
                        width={78}
                        height={40}
                        viewBox="0 0 78 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M77.1992 21.5592C77.5805 21.1779 77.7948 20.6607 77.7948 20.1214C77.7948 19.5821 77.5805 19.0649 77.1992 18.6836L59.9452 1.42962C59.5639 1.04828 59.0467 0.83405 58.5074 0.83405C57.9681 0.834051 57.4509 1.04828 57.0696 1.42962C56.6882 1.81095 56.474 2.32816 56.474 2.86745C56.474 3.40674 56.6882 3.92394 57.0696 4.30528L70.8526 18.0883L2.32038 18.0854C2.05301 18.0854 1.78826 18.1381 1.54125 18.2404C1.29423 18.3427 1.06979 18.4927 0.880728 18.6818C0.69167 18.8708 0.541702 19.0953 0.439387 19.3423C0.337068 19.5893 0.284411 19.854 0.284409 20.1214C0.284409 20.3888 0.337069 20.6535 0.439386 20.9005C0.541705 21.1476 0.691676 21.372 0.880733 21.5611C1.06979 21.7501 1.29423 21.9001 1.54124 22.0024C1.78826 22.1047 2.05301 22.1574 2.32038 22.1574L70.8526 22.1545L57.0696 35.9376C56.6882 36.3189 56.474 36.8361 56.474 37.3754C56.474 37.9147 56.6882 38.4319 57.0696 38.8132C57.4509 39.1945 57.9681 39.4088 58.5074 39.4088C59.0467 39.4088 59.5639 39.1946 59.9452 38.8132L77.1992 21.5592Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
          {/* -end company*/}
          {/* -  archivement-*/}
          <div className="r-archivement">
            <div className="p-home__achievement">
              <div className="p-home__achievement-title">
                <h1>{trans.about.achievement_title}</h1>
                <p>{trans.about.achievement_text}</p>
              </div>
              <div className="p-home__achievement-title-content">
                <div className="p-home__achievement-title-items">
                  <div
                    className="p-home__achievement-title-item"
                    style={{ backgroundColor: '#0063AA' }}
                  >
                    <div className="p-home__achievement-title-item-icon">
                      <img src="assets/img/slider/project.png" alt="" />
                    </div>
                    <div className="p-home__achievement-title-item-number">
                      500+
                    </div>
                    <div className="p-home__achievement-title-item-text">
                      {trans.about.achievement_project}
                    </div>
                  </div>

                  <div
                    className="p-home__achievement-title-item"
                    style={{ backgroundColor: '#FDE002' }}
                  >
                    <div className="p-home__achievement-title-item-icon">
                      <img src="assets/img/slider/customer.png" alt="" />
                    </div>
                    <div
                      className="p-home__achievement-title-item-number"
                      style={{ color: '#0063AA' }}
                    >
                      200+
                    </div>
                    <div
                      className="p-home__achievement-title-item-text"
                      style={{ color: '#0063AA' }}
                    >
                      {trans.about.achievement_customer}
                    </div>
                  </div>

                  <div
                    className="p-home__achievement-title-item"
                    style={{ backgroundColor: '#EB2725' }}
                  >
                    <div className="p-home__achievement-title-item-icon">
                      <img src="assets/img/slider/engineer.png" alt="" />
                    </div>
                    <div className="p-home__achievement-title-item-number">
                      100+
                    </div>
                    <div className="p-home__achievement-title-item-text">
                      {trans.about.achievement_engineer}
                    </div>
                  </div>

                  <div
                    className="p-home__achievement-title-item"
                    style={{ backgroundColor: '#00BE90' }}
                  >
                    <div className="p-home__achievement-title-item-icon">
                      <img src="assets/img/slider/expert.png" alt="" />
                    </div>
                    <div className="p-home__achievement-title-item-number">
                      10+
                    </div>
                    <div className="p-home__achievement-title-item-text">
                      {trans.about.achievement_expert}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* - end archivement-*/}
          {/* customer */}
          <div className="r-customer">
            <div className="container">
              <div className="title-center">
                <h3>{trans?.about?.customer}</h3>
                <p>{trans.about.customer_text}</p>
                <p>{trans.about.customer_text1}</p>
              </div>
            </div>
            <div className="container-fluid">
              <ul className="brands-list">
                <li>
                  <img src="/assets/images/about/brand-7.png" alt="Fujtsu" />
                </li>
                <li>
                  <img src="/assets/images/about/brand-2.png" alt="Viettel" />
                </li>
                <li>
                  <img src="/assets/images/about/ric.svg" alt="Fujtsu" />
                </li>
                <li>
                  <img src="/assets/images/about/qua.svg" alt="Viettel" />
                </li>
                <li>
                  <img src="/assets/images/about/intel.svg" alt="Viettel" />
                </li>
                <li>
                  <img
                    src="/assets/images/about/rf.svg"
                    alt="Doke"
                    style={{ padding: '0 25px' }}
                  />
                </li>
                <li>
                  <img
                    src="/assets/images/about/brand-4.png"
                    alt="Fpt"
                    style={{ padding: '0 25px' }}
                  />
                </li>
                {/* <li>
                  <img src="/assets/images/about/brand-5.png" alt="Netelly" />
                </li> */}
                <li>
                  <img
                    src="/assets/images/about/brand-6.png"
                    alt="Luvina"
                    style={{ padding: '0 25px' }}
                  />
                </li>
                <li>
                  <img
                    src="/assets/images/about/brand-1.png"
                    alt="Tri nam group"
                    style={{ padding: '0 25px' }}
                  />
                </li>
                <li style={{ margin: '0 45px 64px 45px' }}>
                  <img src="/assets/images/about/tue.svg" alt="Novaon" />
                </li>
                <li style={{ margin: '0 45px 64px 45px' }}>
                  <img src="/assets/images/about/brand-9.png" alt="Nhg" />
                </li>
                <li style={{ margin: '0 45px 64px 45px' }}>
                  <img src="/assets/images/about/vinh.svg" alt="Nhg" />
                </li>
                <li style={{ margin: '0 45px 64px 45px' }}>
                  <img src="/assets/images/about/gd.svg" alt="Nhg" />
                </li>
                <li style={{ margin: '0 45px 64px 45px' }}>
                  <img src="/assets/images/about/bk.svg" alt="Nhg" />
                </li>
                <li style={{ margin: '0 45px 64px 45px' }}>
                  <img src="/assets/images/about/kinhky.svg" alt="Nhg" />
                </li>
              </ul>
            </div>
            <div className="map">
              <img
                className="w-100"
                src="/assets/images/about/map-new.png"
                alt="map"
              />
            </div>
          </div>
          {/* end customer */}
        </div>
      </div>
    </>
  );
}
